import React from "react";
import PropTypes from "prop-types";
import { initialize } from "redux-form";
import { documentPropType } from "custom-prop-types";
import styles from "components/upload-documents/awaiting-processing.scss";

export const AwaitingProcessing = ({ focusedDocument, onFocusDocument, pendingDocuments }) => (
  <div>
    { renderAwaitingProcessingList(focusedDocument, onFocusDocument, pendingDocuments) }
  </div>
);

const renderAwaitingProcessingList = (focusedDocument, onFocusDocument, pendingDocuments) => (
  <div className={ `${styles["awaiting-processing-container"]} manual4` }>
    { pendingDocuments.map(document => renderItem(document, focusedDocument, onFocusDocument)) }
  </div>
);

const renderItem = (document, focusedDocument, onFocusDocument) => {
  const newCurrency = focusedDocument.currency || "AUD";
  const initialValues = {
    categories: focusedDocument.categories || [],
    cardNumber: null,
    currency: { key: newCurrency, name: newCurrency },
    formPaymentType: { key: "credit-card", name: "Card" },
    invoiceNumber: focusedDocument.invoiceNumber || "",
    issued: focusedDocument.issued || "",
    notes: focusedDocument.notes || "",
    tax: focusedDocument.tax || 0,
    total: focusedDocument.total || 0,
    vendor: focusedDocument.vendor || ""
  };
  return (
    <div
      className={ highlighter(document, focusedDocument) }
      key={ document.id }
      onClick={ () => { onFocusDocument(document); initialize("pendingReceiptForm", initialValues); } }
    >
      <div>{getDocumentDisplayName(document)}</div>
      <div className={ styles.stuck }>{ renderStuckText(document) }</div>
    </div>
  );
};

const getDocumentDisplayName = (document) => {
  if (document.name) {
    return document.name;
  } else if (document.attachment) {
    return document.attachment.name;
  }
  return "Untitled Document";
};

const highlighter = (document, focusedDocument) => {
  if (focusedDocument === null || document.id !== focusedDocument.id) {
    return styles["pending-item"];
  }
  return `${styles["pending-item"]} ${styles["active-pending-item"]}`;
};

AwaitingProcessing.defaultProps = {
  focusedDocument: null
};

AwaitingProcessing.propTypes = {
  focusedDocument: documentPropType,
  onFocusDocument: PropTypes.func.isRequired,
  pendingDocuments: PropTypes.arrayOf(documentPropType).isRequired
};

const renderStuckText = (document) => {
  if (document.processingState === "NEEDS_OVERALL_PROCESSING"
    && document.queued_for_data_entry === false) {
    return "stuck document";
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/awaiting-processing.jsx